import React, {useCallback, useEffect, useRef, useState} from "react";
import {
  Alert,
  Chip, Divider, Grid,
  Stack
} from "@mui/material";
import Box from "@mui/material/Box";
import {RejectConfirmDialog} from "./RejectConfirmDialog";
import api from "../../../services/api";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {FileUploadDialog} from "./FileUploadDialog";
import {useStateContext} from "../../../hooks/useStateContext";
import CircularProgress from "@mui/material/CircularProgress";
import {ServiceReservationConfirmedCard} from "./ServiceReservationConfirmedCard";
import Typography from '@mui/material/Typography';
import grey from "@mui/material/colors/grey";
import moment from "moment";
import 'moment/locale/hu';
import {SkeletonCard} from "./SkeletonCard";
moment.locale('hu');

interface Props {
  rows: any;
  loading: boolean;
  onLoading: (value: boolean) => void;
  onChangeTab: (value: number) => void;
  onOpenChat: (value: any) => void;
  onRefresh: () => void;
  apiRef: any
  customFields: any
  editableFields: any
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const ConfirmedList: React.ComponentType<Props> = ({
                                                    rows,
                                                    loading,
                                                    onLoading,
                                                    onRefresh,
                                                    onChangeTab,
                                                    apiRef,
                                                    customFields,
                                                    onOpenChat,
                                                    editableFields
                                                  }) => {
  const [typeOfTable, setTypeOfTable] = useState("default");
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [openFileUploadDialog, setOpenFileUploadDialog] = useState<any>(false);
  const [value, setValue] = useState(0);
  const [loadingConfirm, setLoadingConfirm] = useState<boolean>(false);
  const {isMobile, user} = useStateContext();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onChangeTab(newValue);
    setValue(newValue);
  };

  useEffect(() => {
    const uniqueFormattedTypes = rows
      .map((item: any) => item.formatted_type)
      .filter((value: any, index: any, self: any) => self.indexOf(value) === index);

    let newTypeOfTable = "default";

    if (uniqueFormattedTypes.some((type: any) => type === "event-staff" || type === "event-staff-airport-transfer")) {
      newTypeOfTable = "event-staff";
    }

    if (uniqueFormattedTypes.some((type: any) => type === "transfer" || type === "airport-transfer")) {
      newTypeOfTable = "transfer";
    }

    setTypeOfTable(newTypeOfTable);
  }, [rows]);

  const handleRejectConfirmation = (confirmation: any) => {
    onSubmit(confirmation?.service_reservation_id, confirmation?.id);
  };

  const onSubmit = useCallback(
    (
      reservationId: any,
      confirmationId: any,
    ) => {
      onLoading(true);
      setLoadingConfirm(true);
      api
        .post(
          `/service-provider/service-reservation-confirmations/${reservationId}/${confirmationId}`,
          {
            action: 'decline-confirmed',
          }
        )
        .then((result: any) => {
          onRefresh();
        })
        .catch((error: any) => {
        })
        .finally(() => {
          onLoading(false);
          setLoadingConfirm(false);
          setOpenConfirmDialog(false);
        });

    },
    [onRefresh, onLoading, setOpenConfirmDialog]
  );


  const [visibleCount, setVisibleCount] = useState(10); // start with 10
  const loaderRef = useRef(null);

  // Group rows by date (assuming item.date is a valid date string)
  const grouped = rows.reduce((acc:any, item:any) => {
    const date = new Date(item.raw_date).toLocaleDateString();
    if (!acc[date]) acc[date] = [];
    acc[date].push(item);
    return acc;
  }, {} as Record<string, any[]>);

  // Flatten grouped rows into an array like: [{ date, items: [...] }, ...]
  const groupedArray = Object.entries(grouped).map(([date, items]) => ({
    date,
    items,
  }));

  // Flatten for lazy loading, but keep date references
  const flattened = groupedArray.flatMap(({ date, items }:{date:any, items:any}) =>
    items.map((item:any, index:any) => ({
      item,
      date,
      isFirstOfDay: index === 0,
    }))
  );
  const visibleItems = flattened.slice(0, visibleCount);

  // Infinite scroll trigger
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && visibleCount < flattened.length) {
          setVisibleCount((prev) => prev + 10); // load next 10
        }
      },
      { threshold: 1 }
    );
    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [visibleCount, flattened.length]);

  return (
    <>
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        marginBottom: '10px'
      }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Jelenlegi foglalások" {...a11yProps(0)} />
          <Tab label="Múltbéli foglalások" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <Box>

        <Grid container spacing={2}>
          {loading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <Grid item xs={12} md={6} lg={4} xl={3} key={index}>
                <SkeletonCard />
              </Grid>
            ))
          ) : (
            <>
              {rows.length === 0 && (
                <Grid item xs={12} md={12}>
                  <Alert severity="info">Jelenleg nincs megválaszolt lekérés</Alert>
                </Grid>
              )}
              {/*{rows.map((item: any) => {
                return (
                  <Grid item xs={12} md={6} lg={4} xl={3}>
                    <ServiceReservationConfirmedCard
                      onRefresh={() => {

                      }}
                      item={item}
                      past={value}
                      onOpenChat={(value:any)=> onOpenChat(value)}
                      setOpenConfirmDialog={(value:any)=> setOpenConfirmDialog(value)}
                      setOpenFileUploadDialog={(value:any)=> setOpenFileUploadDialog(value)}
                    />
                  </Grid>
                );
              })}*/}

              {visibleItems.map(({ item, date, isFirstOfDay }, index) => (
                <React.Fragment key={index}>
                  {isFirstOfDay && (
                    <Grid item xs={12}>
                      <Stack alignItems={'center'} direction={'row'}>
                        <Chip
                          size={'small'}
                          sx={{
                            flexShrink: 0
                          }}
                          label={<Typography
                            variant={'body2'}
                            color={grey[700]}
                          >
                            {date ? moment(date).format('YYYY.MM.DD dddd') : ''}
                          </Typography>}
                        />
                        <Box sx={{
                          width: '100%'
                        }}>
                          <Divider />
                        </Box>
                      </Stack>
                    </Grid>
                  )}
                  <Grid item xs={12} md={6} lg={4} xl={3}>
                    <ServiceReservationConfirmedCard
                      item={item}
                      past={value}
                      onRefresh={() => {}}
                      onOpenChat={(val) => onOpenChat(val)}
                      setOpenConfirmDialog={(val) => setOpenConfirmDialog(val)}
                      setOpenFileUploadDialog={(val) => setOpenFileUploadDialog(val)}
                    />
                  </Grid>
                </React.Fragment>
              ))}
            </>
          )}
        </Grid>

        <Stack ref={loaderRef} alignItems={'center'} justifyContent={'center'}>
          <CircularProgress size={30} />
        </Stack>

      </Box>


      {openConfirmDialog && (
        <RejectConfirmDialog
          clickOnReject={() => {
            handleRejectConfirmation(openConfirmDialog);
          }}
          loading={loadingConfirm}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
        />
      )}

      {openFileUploadDialog && (
        <FileUploadDialog
          row={openFileUploadDialog}
          onClose={() => {
            setOpenFileUploadDialog(false);
          }}
        />
      )}
    </>
  );

}
function stripHtml(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}